<template>
    <div class="pd-l-20 pd-r-20 pd-t-20 dp-fx fx-al-st comment-item">
        <img :src="data.photoURL" :alt="data.userName" class="br-rd-pr-50"/>
        <div class="mg-l-10">
            <div class="dp-fx fx-al-ct">
                <div class="fz-14 fw-7 txt-capitalize">{{data.userName}}</div>
                <div class="fz-14 fw-4 mg-l-6">
                    <time-ago :datetime="getDateTime(data)" refresh :locale="locale" :tooltip="tooltip" :long="longString"></time-ago>
                </div>
            </div>
            <div class="mg-t-4 fz-14">{{data.content}}</div>
        </div>
    </div>
</template>

<script>
    import TimeAgo from "vue2-timeago";
    export default {
        name : 'Comment',
        components : {
            TimeAgo : TimeAgo
        },
        props : {
            data : Object
        },
        data : function () {
            return {
                longString: true,
                tooltip: true,
                locale: "en",
            }
        },
        methods : {
            getDateTime(data) {
                let t = new Date(1970, 0, 1), offset = (new Date()).getTimezoneOffset() * -1 * 60;
                if(typeof data.createdOn.seconds == 'undefined')
                    t.setSeconds(data.createdOn.getTime());
                else
                    t.setSeconds(data.createdOn.seconds + offset);
                return t;
            }
        }
    }
</script>

<style>
    .comment-item img{
        width: 28px;
        height: 28px;
        flex-basis: 28px;
    }
    .txt-capitalize{
        text-transform: capitalize;
    }
    .v-time-ago__text{
        color: #8d8f9f !important;
    }
</style>